export const DROPDOWN_SCROLL_HEIGHT = "500px";
//export const API_BASE = "http://localhost:5000";
export const API_BASE = "https://pvpocomingsoon.scinet.usda.gov/api/amsapi?";
//export const API_BASE = "https://pvpocomingsoon.scinet.usda.gov/api/amsapi?code=MJkiYQxhrDA23-DR969eMpOHhPZh-Gq5MhJjk6FGHU3pAzFu-T614w==";
//export const API_BASE = "https://ams-api.prodv2-app-serv-env.appserviceenvironment.net/api/amsapi?code=MJkiYQxhrDA23-DR969eMpOHhPZh-Gq5MhJjk6FGHU3pAzFu-T614w==";
